import { render, staticRenderFns } from "./VInfoField.vue?vue&type=template&id=303d7fdc&"
import script from "./VInfoField.vue?vue&type=script&lang=js&"
export * from "./VInfoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports